import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
import {
	ButtonView,
	ContextualBalloon,
	View,
	clickOutsideHandler
} from '@src/plugins/ckeditor5-ui/src/index';
import LinkForm from './linkForm';
// import ButtonView from '@src/plugins/ckeditor5-ui/src/button/buttonview'
import selectFileIcon from '../theme/icons/selectFile.svg';
// import ButtonView from  '@src/plugins/ckeditor5-ui/src/button/buttonview'
export default class SelectFileUI extends Plugin {
	static get requires() {
		return [ ContextualBalloon ];
	}
	static get pluginName() {
		return 'SelectFileUI';
	}

	init() {
		const editor = this.editor;
		this._balloon = editor.plugins.get( ContextualBalloon );

		this.selectValue = {};
		this.formView = this._createFormView();
		this.positions = editor.config.get( 'selectFile.resource' );
		const viewDocument = editor.editing.view.document;
		this.listenTo( viewDocument, 'click', ( evt, data ) => {
			data.preventDefault();
		} );

		this.listenTo( this.formView, 'clickLiButton', ( item, evt ) => {
			// console.log( evt.target.getAttribute( 'value' ) );
			const liValue = evt.target.getAttribute( 'value' );
			const selectArr = this.positions.filter(
				item => item.value === liValue
			);
			if ( selectArr.length > 0 ) {
				this.selectValue.href = selectArr[ 0 ].value;
				this.selectValue.title = selectArr[ 0 ].name;
				this.selectValue.filetype = selectArr[ 0 ].filetype;
				this.selectValue.src = selectArr[ 0 ].src;
				this.selectValue.attachmentId = selectArr[ 0 ].attachmentId;
				editor.execute( 'selectFile', this.selectValue );
			}
			this._closeFormView();
		} );

		this.listenTo( this.formView, 'cancel', () => {
			this._closeFormView();
		} );
		this._enableUserBalloonInteractions();
		editor.ui.componentFactory.add( 'selectFile', locale => {
			const view = new ButtonView( locale );
			const command = editor.commands.get( 'selectFile' );
			view.set( {
				label: '资料文件引用',
				icon: selectFileIcon,
				tooltip: true
			} );

			view.bind( 'isEnabled' ).to( command );
			this.listenTo( view, 'execute', () => {
				// 点击按钮的时候打开弹窗
				this._openDialog();
			} );
			return view;
		} );
	}
	_enableUserBalloonInteractions() {
		clickOutsideHandler( {
			emitter: this.formView,
			activator: () => this._isFormInPanel,
			contextElements: [ this._balloon.view.element ],
			callback: () => this._closeFormView()
		} );
	}
	_createFormView() {
		const editor = this.editor;
		const positions = editor.config.get( 'selectFile.resource' );
		const view = new LinkForm( editor.locale, positions );
		return view;
	}
	get _isFormInPanel() {
		return this._balloon.hasView( this.formView );
	}
	_openDialog() {
		if ( this._isFormInPanel ) {
			return;
		}
		this._balloon.add( {
			view: this.formView,
			position: this._getBalloonPositionData()
		} );
	}
	_getBalloonPositionData() {
		const view = this.editor.editing.view;
		const viewDocument = view.document;
		let target = null;
		// Make sure the target is calculated on demand at the last moment because a cached DOM range
		// (which is very fragile) can desynchronize with the state of the editing view if there was
		// any rendering done in the meantime. This can happen, for instance, when an inline widget
		// gets unlinked.
		target = () => {
			return view.domConverter.viewRangeToDom(
				viewDocument.selection.getFirstRange()
			);
		};
		return { target };
	}
	_closeFormView() {
		if ( !this._isFormInPanel ) {
			return;
		}
		const editor = this.editor;
		this.stopListening( editor.ui, 'update' );
		this.stopListening( this._balloon, 'change:visibleView' );
		editor.editing.view.focus();
		this._balloon.remove( this.formView );
	}
}
